<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop d-flex justify-content-md-center">
        <div class="col-md-6">
          <v-toolbar color="#01579B" class="top-hero6" dark flat>
            <v-toolbar-title>Login Form</v-toolbar-title>
          </v-toolbar>
          <v-form>
            <v-card-text class="card">
              <v-text-field
                label="email"
                name="email"
                v-model="form.email"
                prepend-icon="mdi-account"
                type="email"
              ></v-text-field>
              <span class="text-danger" v-if="errors.email">
                {{ errors.email[0] }}
              </span>

              <v-text-field
                v-model="form.password"
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
              ></v-text-field>
              <span class="text-danger" v-if="errors.password">
                {{ errors.password[0] }}
              </span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                small
                color="error"
                data-toggle="modal"
                data-target="#exampleModal"
                >Forgot Password?</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="#01579B"
                class="text-white"
                :disabled="form.email == '' || form.password == ''"
                @click.prevent="login"
                >Login</v-btn
              >
            </v-card-actions>
          </v-form>

          <!-- Modal -->
          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <v-card class="elevation-12">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>Forgot Password</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-form ref="form" v-model="valid2">
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="newEmail.email"
                              :rules="emailRules"
                              label="E-mail"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-btn
                        :disabled="!valid2"
                        color="info"
                        class="mr-4"
                        @click="passForgot()"
                      >
                        Send Email
                      </v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    source: String
  },

  data() {
    return {
      valid2: true,
      form: {
        email: "",
        password: ""
      },
      errors: [],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      newEmail: {
        email: ""
      }
    };
  },

  methods: {
    login() {
      this.$store
        .dispatch("login", this.form)
        .then(() => {
          this.$router.push({ name: "Dashboard" });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    },

    passForgot() {
      window.axios.get("/sanctum/csrf-cookie").then(() => {
        window.axios.post("/password/email", this.newEmail).then(() => {
          this.$router.push({ name: "checkEmail" });
        });
      });
    }
  }
};
</script>
